import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import { styleVariables } from '@lib/common';
import { Space, Skeleton, Row, Col } from 'antd';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StyledInformationCard = styled.div.withConfig({
  displayName: "base-submission-informationcomponent__StyledInformationCard",
  componentId: "sc-1vsykag-0"
})(["border-radius:16px;box-shadow:0px 3px 6px rgba(0,0,0,0.12);background-color:", ";padding:16px 16px 16px 16px;"], styleVariables.colors.gray1);
var UserInformationCard = styled.div.withConfig({
  displayName: "base-submission-informationcomponent__UserInformationCard",
  componentId: "sc-1vsykag-1"
})(["border-radius:8px;padding:16px;"]);
var AvatarCircle = styled.div.withConfig({
  displayName: "base-submission-informationcomponent__AvatarCircle",
  componentId: "sc-1vsykag-2"
})(["width:56px;height:56px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background-color:", ";color:", ";font-weight:700;font-size:18px;margin-right:12px;"], styleVariables.colors.blue1, styleVariables.colors.blue2);
var UserRow = styled.div.withConfig({
  displayName: "base-submission-informationcomponent__UserRow",
  componentId: "sc-1vsykag-3"
})(["display:flex;align-items:center;"]);
var AssignmentTitle = styled.label.withConfig({
  displayName: "base-submission-informationcomponent__AssignmentTitle",
  componentId: "sc-1vsykag-4"
})(["font-weight:700;font-size:24px;line-height:40px;color:", ";"], styleVariables.colors.gray13);
var StyledSpace = styled(Space).withConfig({
  displayName: "base-submission-informationcomponent__StyledSpace",
  componentId: "sc-1vsykag-5"
})(["width:100%;"]);
var BoldText = styled.label.withConfig({
  displayName: "base-submission-informationcomponent__BoldText",
  componentId: "sc-1vsykag-6"
})(["font-weight:600;font-size:14px;", ""], function (props) {
  return props.theme.media.desktop(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-size: 16px;\n  "])));
});
var GrayText = styled.label.withConfig({
  displayName: "base-submission-informationcomponent__GrayText",
  componentId: "sc-1vsykag-7"
})(["font-weight:400;font-size:14px;line-height:24px;color:", ";", ""], styleVariables.colors.gray11, function (props) {
  return props.theme.media.desktop(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    font-size: 16px;\n  "])));
});
var InformationSummary = styled(Row).withConfig({
  displayName: "base-submission-informationcomponent__InformationSummary",
  componentId: "sc-1vsykag-8"
})([""]);
var ResultCol = styled(Col).withConfig({
  displayName: "base-submission-informationcomponent__ResultCol",
  componentId: "sc-1vsykag-9"
})(["display:flex;"]);
var ResultWrapper = styled.div.withConfig({
  displayName: "base-submission-informationcomponent__ResultWrapper",
  componentId: "sc-1vsykag-10"
})(["display:flex;flex-direction:column;width:100%;flex:1;& > *{height:100%;}.ant-col{max-width:none !important;}"]);
export var BaseSubmissionInformation = function BaseSubmissionInformation(props) {
  var isLoadingGetAttendeeById = props.isLoadingGetAttendeeById,
      children = props.children,
      assignment = props.assignment,
      isLoadingGetAssignmentById = props.isLoadingGetAssignmentById,
      attendee = props.attendee,
      label = props.label,
      resultColumn = props.resultColumn,
      _props$shouldShowTitl = props.shouldShowTitle,
      shouldShowTitle = _props$shouldShowTitl === void 0 ? true : _props$shouldShowTitl,
      userExtra = props.userExtra;

  var renderUserInformation = function renderUserInformation() {
    var _attendee$firstName, _attendee$lastName;

    if (isLoadingGetAttendeeById) {
      return /*#__PURE__*/_jsx(Skeleton, {
        active: true
      });
    }

    return /*#__PURE__*/_jsx(Space, {
      direction: "vertical",
      style: {
        width: '100%'
      },
      children: /*#__PURE__*/_jsxs(UserRow, {
        children: [/*#__PURE__*/_jsxs(AvatarCircle, {
          children: [(((_attendee$firstName = attendee.firstName) === null || _attendee$firstName === void 0 ? void 0 : _attendee$firstName[0]) || '').toUpperCase(), (((_attendee$lastName = attendee.lastName) === null || _attendee$lastName === void 0 ? void 0 : _attendee$lastName[0]) || '').toUpperCase()]
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsxs(BoldText, {
            children: [attendee.firstName, " ", attendee.lastName]
          }), /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(GrayText, {
              children: attendee.email
            })
          }), userExtra && /*#__PURE__*/_jsx("div", {
            children: userExtra
          })]
        })]
      })
    });
  };

  var renderAssignmentTitle = function renderAssignmentTitle() {
    if (isLoadingGetAssignmentById) {
      return /*#__PURE__*/_jsx(Skeleton.Button, {
        size: "large",
        block: true,
        active: true
      });
    }

    return /*#__PURE__*/_jsx(_Fragment, {
      children: shouldShowTitle && /*#__PURE__*/_jsx(AssignmentTitle, {
        children: assignment.title
      })
    });
  };

  return /*#__PURE__*/_jsx(StyledInformationCard, {
    children: /*#__PURE__*/_jsxs(StyledSpace, {
      direction: "vertical",
      size: "small",
      children: [renderAssignmentTitle(), /*#__PURE__*/_jsxs(InformationSummary, {
        gutter: 16,
        children: [/*#__PURE__*/_jsx(Col, {
          xs: 24,
          xl: 16,
          flex: "auto",
          children: /*#__PURE__*/_jsxs(Space, {
            direction: "vertical",
            size: "small",
            style: {
              width: '100%'
            },
            children: [/*#__PURE__*/_jsx(UserInformationCard, {
              children: renderUserInformation()
            }), /*#__PURE__*/_jsx("div", {
              children: children
            })]
          })
        }), /*#__PURE__*/_jsx(ResultCol, {
          xs: 24,
          xl: 8,
          flex: "auto",
          children: /*#__PURE__*/_jsx(ResultWrapper, {
            children: resultColumn
          })
        })]
      })]
    })
  });
};